export default __webpack_public_path__ + "static/media/PM10.0aeafbac.svg";